import { CustomElement } from '@aurelia/runtime-html';
export const name = "removed-team";
export const template = "<template>\n  <span class=\"team\"  style=\"border:1px; border-style: solid; padding: 5px\" draggable=\"true\" dragstart.trigger=\"dragTeam($event)\" drop.trigger=\"dropTeam($event)\" dragover.trigger=\"allow($event)\">${teamName} <sup>${gamesLeft}</sup></span>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
